<template>
	<div class="online qjc-relative">
		<div class="doctor-det qjc-fl">
			<img class="qjc-wid-100" src="../../../assets/images/dayu_online_doctor_large.png" alt="">
			
			<dl class="qjc-wid-100">
				<dt class="qjc-fts-32 qjc-texta-c">
					<b>邹萍</b>
					<p class="qjc-fts-28">全科医生</p>
				</dt>
				<dd class="qjc-fts-28">毕业于上海交通医学院临床专业，从医超过38年，对内外科疾病有丰富的临床经验，并通过英美系家庭医生系统培训。尤其擅长慢病管理、健康患教、疾病预防及生活方式指导。</dd>
			</dl>
		</div>
		
		<div class="box qjc-fr qjc-texta-c">
			<h4 class="qjc-fts-34 qjc-ftw-n qjc-c-dark">在线咨询</h4>
		
			<div class="dialog">
				<div ref="scroll">
					<div class="content" ref="content">
						<p>欢迎进入在线咨询</p>
						<p>{{ consoltTime }}</p>
						<div v-for="item in details" v-if="item.contentType == 1" :key="item.id" :class="item.type == 1?'ask':'anser'">
							<img class="head" :src="require('@/assets/images/'+ (item.type == 1?'dayu_online_ask':'dayu_online_doctor') +'.png')" alt="">
							<div class="text">
								{{ JSON.parse(item.content).text }}
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="ripple">
				<ul ref="ripples">
					<li 
						v-for="i in 26" 
						:style="{ 
							left: (i-13)*0.11 + 'rem',
							width: parseInt(remPx/28)+'px'
						}"
					></li>
				</ul>
			</div>
			
			<div class="send-box qjc-clearfix">
				<input v-model="sendContent" autocomplete="off" id="send" class="qjc-fl" type="text">
				<span @click="ask" class="send-btn qjc-fl qjc-fts-28 qjc-ftw-n qjc-c-fff">发送</span>
			</div>
			
		</div>
		
		<dl class="code qjc-absolute qjc-texta-c">
			<dt>
				<img src="../../../assets/images/dayu_online_code.png" alt="">
			</dt>
			<dd class="qjc-fts-24 qjc-c-fff">扫码手机咨询</dd>
		</dl>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Toast } from 'vant'
	Vue.use(Toast);
	
	import { onlineAsk, getOnlineDetail } from '@/utils/axios'
	
	export default{
		name: 'dayuOnline',
		data() {
			return {
				sendContent: '',
				
				consoltTime: '',
				consultId: '',
				details: [],
				
				timer: '',
				
				remPx: document.querySelector('html').style.fontSize.replace('px','') // 取整px防止浏览器小数不精确波纹宽度不一致
			}
		},
		mounted() {
			var that = this;
			
			this.$nextTick(() => {
				
				this.$refs.ripples.children.forEach(item => {
					item.style.height = '1px';// 触发transitionend事件
					
					item.addEventListener('transitionend', () => {
						that.rippleSet(item);
					});
					
					setTimeout(()=>{
						that.rippleSet(item);
					},100);
					
				});
				
				
			});
		},
		methods: {
			ask() {
				if(this.sendContent != ''){
					var askData = {
						contentType: 1,// 提问类型：1文字、2图片、3语音
						content: JSON.stringify({ "text": this.sendContent })
					}
					// 是否首次(首次不需要id)
					if(this.consultId){
						askData.consultId = this.consultId;
					}
					
					var that = this;
					
					onlineAsk(JSON.stringify(askData)).then(res => {
						console.log(res);
						if(res.errno == 0){
							// 首次请求完成重复请求详情即时更新
							if(!askData.consultId){
								that.timer = setInterval(that.getDetail, 1000);
							}
							
							that.consultId = res.data.consultId;
							that.getDetail(() => {
								var ele = that.$refs.scroll;
								//判断元素是否出现了滚动条
								if(ele.scrollHeight > ele.clientHeight) {
									console.log(ele.scrollHeight)
									//设置滚动条到最底部
									ele.scrollTop = ele.scrollHeight;
								}
							});
							
							// 清空输入框
							that.sendContent = '';
							
						}else{
							Toast.fail(res.errmsg);
						}
						
					});
					
				}else{
					Toast.fail('请输入内容');
				}
			},
			
			getDetail(callback){
				var that = this;
				
				getOnlineDetail(this.consultId).then(res => {
					// console.log(res)
					if(res.errno == 0){
						that.consoltTime = res.data.consoltTime;
						that.details = res.data.details;
						
						that.$nextTick(() => {
							callback?callback():'';
						})
					}else{
						Toast.fail(res.errmsg);
					}
				});
				
			},
			
			rippleSet(item) {// 设置每条波纹属性 参数: 波纹dom
				var itemStyle = item.style,
					height = this.rdm(32,0)/100;
				itemStyle.transitionDuration = this.rdm(0.6, 0.3) + 's';
				itemStyle.height = height + 'rem';
				itemStyle.marginTop = -height/2 + 'rem';
			},
			
			rdm(max, min) {
				return Math.random()*(max-min)+min;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.online{
		height: 9.9rem;
		padding-top: 0.48rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		
		.doctor-det{
			width: 3.52rem;
			margin-left: 0.37rem;
			border: 0.01rem solid #5FD6FF;
			border-radius: 0.08rem;
			overflow: hidden;
			
			img{
				display: block;
				height: 3.57rem;
			}
			dt{
				color: #5FD6FF;
				padding: 0.16rem 0;
				line-height: 0.36rem;
				background: rgba(95, 214, 255, 0.1);
				box-shadow: 0 0.01rem 0.36rem 0 inset rgba(60, 209, 255, .29);
			}
			dd{
				text-indent: 2em;
				color: #E1E7F5;
				font-weight: 400;
				line-height: 0.46rem;
				padding: 0.24rem;
				text-align: justify;
			}
		}
		
		.box{
			width: 12.94rem;
			border-radius: 0.08rem;
			background-color: rgba(72, 76, 94, .29);
			margin-right: 2.05rem;
			overflow: hidden;
			
			h4{
				position: relative;
				background-color: #F0F5FF;
				line-height: 0.34rem;
				padding: 0.24rem 0;
				z-index: 200;
			}
			
			.dialog{
				position: relative;
				height: 6.62rem;
				box-shadow: 0 0.4rem 0.4rem 0 inset #3CD1FF;
				margin-top: -0.6rem;
				overflow: hidden;
				z-index: 100;
				
				&>div{
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					overflow-y: auto;
				}
				.content{
					min-height: 100%;
					padding: 0.84rem 0.48rem 0.64rem;
					
					p{
						color: #8993A2;
						font-size: 0.20rem;
						line-height: 0.20rem;
						margin-bottom: 0.12rem;
					}
					&>div{
						margin-bottom: 0.16rem;
						
						&.ask::after,
						&.anser::after{
							content: '';
							display: block;
							clear: both;
						}
						
						.head{
							width: 0.88rem;
							height: 0.88rem;
						}
						.text{
							max-width: 10rem;
							text-align: left;
							background-color: #FAFAFC;
							color: #40444D;
							line-height: 0.42rem;
							font-size: 0.28rem;
							font-weight: 400;
							padding: 0.16rem 0.24rem;
							margin: 0.24rem 0.16rem 0;
							border-radius: 0 0.16rem 0.16rem 0.16rem;
						
						}
						
						&.anser{
							.head,
							.text{
								float: left;
							}
						}
						&.ask{
							.head,
							.text{
								float: right;
							}
							.text{
								border-radius: 0.16rem 0 0.16rem 0.16rem;
							}
						}
					}
				}
			}
			
			.ripple{
				position: relative;
				height: 1.52rem;
				box-shadow: 0 -0.4rem 0.4rem 0 inset #3CD1FF;
				margin-bottom: -0.6rem;
				overflow: hidden;
				z-index: 10;
				
				ul{
					position: absolute;
					top: 0.46rem;
					left: 50%;
					transform: translateX(-50%);
					
					li{
						position: absolute;
						background-color: #5FD6FF;
						border-radius: 0.02rem;
						transition-property: all;
					}
				}
			}
			
			.send-box{
				position: relative;
				padding: 0.16rem 0.24rem;
				background-color: #E9F0FF;
				box-shadow: 0 -0.02rem 0.11rem 0 rgba(66, 74, 84, 0.4);
				margin-top: -0.4rem;
				z-index: 200;
				
				#send{
					width: 10.2rem;
					font-size: 0.28rem;
					height: 0.76rem;
					line-height: 0.28rem;
					padding: 0.24rem 0.42rem;
					background-color: #fff;
					color: #40444D;
					border: none;
					border-radius: 0.38rem;
					margin-right: 0.24rem;
					vertical-align: middle;
					
					&:focus{
						border: none;
						outline: none;
					}
				}
				.send-btn{
					width: 2.02rem;
					height: 0.76rem;
					line-height: 0.76rem;
					background-color: #4A5069;
					border-radius: 0.08rem;
					cursor: pointer;
					vertical-align: middle;
				}
			}
		}
		
		.code{
			right: 0.29rem;
			bottom: 0.6rem;
			
			dt{
				img{
					width: 1.28rem;
					height: 1.28rem;
				}
			}
			dd{
				line-height: 0.24rem;
				margin-top: 0.16rem;
			}
		}
	}
</style>
